module.exports = __webpack_public_path__ + "static/facebook-f403b3df2e4e7f04176cee2453bb0dc2.svg";